'use client';

import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { useQuery } from '@tanstack/react-query';
import { chunk } from 'es-toolkit';
import { useState } from 'react';
import { UnauthQueryOptions } from '@/api';
import { RecentOrderGiftList } from './RecentOrderGiftList';
const recentGiftProductsQueryOptions = UnauthQueryOptions['get:/wello/v2/allows/home-love/main/recent-gift-products'];
export type RecentOrderGiftItem = NonNullable<NonNullable<Awaited<ReturnType<NonNullable<ReturnType<typeof recentGiftProductsQueryOptions>['queryFn']>>>['context']>['contents']>[number];
interface RecentOrderGiftsSectionProps {
  className?: string;
}

/**
 * 클라이언트에서 실시간 로딩 섹션
 */
export const RecentOrderGiftsSection = t0 => {
  const $ = _c(30);
  const {
    className
  } = t0;
  const [currentIndex, setCurrentIndex] = useState(0);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      ...recentGiftProductsQueryOptions(),
      staleTime: 30000,
      gcTime: 300000,
      refetchOnWindowFocus: true,
      retry: 3,
      select: _temp
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    data: t2,
    isLoading: isGiftListLoading,
    isError: isGiftListError
  } = useQuery(t1);
  let chunkedList;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  if ($[1] !== className || $[2] !== currentIndex || $[3] !== isGiftListError || $[4] !== isGiftListLoading || $[5] !== t2) {
    t8 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const recentGiftProductList = t2 === undefined ? [] : t2;
      chunkedList = chunk(recentGiftProductList, CHUNK_SIZE);
      const isShowCarousel = recentGiftProductList.length > CHUNK_SIZE;
      const shouldHideSection = !isGiftListLoading && recentGiftProductList.length === 0 || isGiftListError;
      if (shouldHideSection) {
        t8 = null;
        break bb0;
      }
      if ($[13] !== className) {
        t7 = cn("flex flex-col items-center gap-16 px-40 content-container", "mobile-tablet:px-0", className);
        $[13] = className;
        $[14] = t7;
      } else {
        t7 = $[14];
      }
      if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = cn("relative w-full gap-2 flex-center", "mobile-tablet:justify-start mobile-tablet:gap-4 mobile-tablet:px-20");
        t4 = <span className={cn("mr-4 typo-h4", "mobile-tablet:mr-2 mobile-tablet:typo-body1")}>📦</span>;
        t5 = <h2 className={cn("bg-gradient-to-r from-O-500 to-R-500 bg-clip-text font-800 text-transparent typo-h4", "mobile-tablet:font-700 mobile-tablet:typo-body1")}>전국에서 실시간 주문중!</h2>;
        $[15] = t3;
        $[16] = t4;
        $[17] = t5;
      } else {
        t3 = $[15];
        t4 = $[16];
        t5 = $[17];
      }
      t6 = isShowCarousel ? <div className={cn("absolute bottom-0 right-12 flex translate-y-1/2 items-center gap-10 px-12 py-8", "mobile-tablet:bottom-1/2 mobile-tablet:right-20 mobile-tablet:translate-y-1/2 mobile-tablet:gap-6")}>{chunkedList.map((_, chunkIndex) => <div key={chunkIndex} className={cn("size-4 rounded-pill bg-Gray-400 transition-colors duration-300", {
          "bg-Gray-500 size-6 mobile-tablet:size-4": chunkIndex === currentIndex
        })} />)}</div> : null;
    }
    $[1] = className;
    $[2] = currentIndex;
    $[3] = isGiftListError;
    $[4] = isGiftListLoading;
    $[5] = t2;
    $[6] = chunkedList;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
    $[12] = t8;
  } else {
    chunkedList = $[6];
    t3 = $[7];
    t4 = $[8];
    t5 = $[9];
    t6 = $[10];
    t7 = $[11];
    t8 = $[12];
  }
  if (t8 !== Symbol.for("react.early_return_sentinel")) {
    return t8;
  }
  let t9;
  if ($[18] !== t3 || $[19] !== t4 || $[20] !== t5 || $[21] !== t6) {
    t9 = <header className={t3}>{t4}{t5}{t6}</header>;
    $[18] = t3;
    $[19] = t4;
    $[20] = t5;
    $[21] = t6;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  let t10;
  if ($[23] !== chunkedList || $[24] !== isGiftListLoading) {
    t10 = <RecentOrderGiftList isLoading={isGiftListLoading} listItems={chunkedList} onSlideChange={setCurrentIndex} />;
    $[23] = chunkedList;
    $[24] = isGiftListLoading;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== t10 || $[27] !== t7 || $[28] !== t9) {
    t11 = <section className={t7}>{t9}{t10}</section>;
    $[26] = t10;
    $[27] = t7;
    $[28] = t9;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  return t11;
};
const CHUNK_SIZE = 3;
function _temp(data) {
  return data.context?.contents ?? [];
}